export default __webpack_public_path__ + "static/media/loading.7c2d324b.svg";